module.exports = __webpack_public_path__ + "static/media/demo-1-min.c301bede.png";